module.exports = __webpack_public_path__ + "img/madden_bracket.69b70cd4.png";